import script from "./GeoDataListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoDataListModal.vue?vue&type=script&setup=true&lang=ts"

import "./GeoDataListModal.vue?vue&type=style&index=0&id=a44540d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a44540d6"]])

export default __exports__